import styled, { keyframes } from 'styled-components';

const backdropAnimation = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  overflow: hidden;
  animation: ${backdropAnimation} 0.4s;
  transition: opacity 0.3s;
  padding: ${({ theme }) => theme.spacing['2xs']};

  display: flex;
  align-items: center;
  justify-content: center;
`;
